import React, { useEffect, useState } from "react";
import { ApiService } from "../services";
import { useSnackbar } from "notistack";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../Elements/GButton";
import useDataFctory from "../useDataFactory";
import { ReactComponent as ArrowBackIos } from "../assets/images/arrowBack.svg";

export default function CancelReasons(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { data: orderCancelReasons } = useDataFctory("cancel_reasons", false, {
    user_type: 2,
  });

  useEffect(() => {
    orderCancelReasons.push({ title: "Other" });
  }, [orderCancelReasons]);

  const initialValues = {
    cancel_reason: "",
    other_reason: "",
  };

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    console.log(values);
    let sendData = { ...values };
    if (sendData.cancel_reason !== "Other") {
      delete sendData.other_reason;
    } else {
      sendData.cancel_reason = sendData.other_reason;
    }

    ApiService({
      method: "PUT",
      route: "order/cancel/" + props.linkedId,
      body: sendData,
    }).then((response) => {
      console.log(response.data);
      if (response.data.status_code === 1) {
        props.setOcrvisible(false);
        props.onSubmit();
      }
      enqueueSnackbar(response.data.message);
      setIsBtnDisabled(false);
    });
  };

  const validationSchema = Yup.object({
    cancel_reason: Yup.string().required("Required"),
    other_reason: Yup.string().when("cancel_reason", {
      is: "Other",
      then: Yup.string().required("Required"),
    }),
  });

  if (props.ocrvisible === false) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="modal-header">
        <ArrowBackIos
          className="backIcon"
          onClick={() => props.setCpvisible(false)}
        />
        Cancel Booking
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values }) => (
            <Form>
              <label style={{ margin: "15px 15px 5px" }}>
                Please choose the cancellation reason below
              </label>
              {orderCancelReasons.length > 0 && (
                <FormikControl
                  control="radio"
                  name="cancel_reason"
                  options={orderCancelReasons}
                  key_title="title"
                  custom={true}
                  key_value="title"
                  divstyle={{ display: "block", padding: "5px 0" }}
                />
              )}
              {values.cancel_reason === "Other" ? (
                <FormikControl
                  control="input"
                  as="textarea"
                  placeholder="Type reason here"
                  name="other_reason"
                />
              ) : (
                ""
              )}

              <GButton
                type="submit"
                disabled={isBtnDisabled}
                variant="condensed"
                children="Cancel Booking"
                style={{ width: "calc(100% - 30px)", margin: "20px 15px" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </React.Fragment>
  );
}
